<template>
  <div class="invoice__payment">
    <vs-popup id="invoice__payment" classContent="popup-example payment_popup" title="Payments" button-accept="false" button-cancel="false" :active.sync="is_invoice_popup_active">
      <div class="vx-row payment_content px-5">
        <div class="vx-col w-full lg:w-3/5 sm:w-3/5">
          <!-- Transporter Details -->
          <div class="transporter_details p-1 mb-2" v-for="(input, k) in paymentrows" :key="k">
            <!-- close btn -->
            <vs-button v-if="k > 0" radius class="close__btn" type="border" icon-pack="feather" icon="icon-x" @click="removePaymentrow(k)"></vs-button>

            <!-- transporter -->
            <div class="transporter mb-2" v-if="k === 0">
              <label for="transporters">Transporter</label>
              <select-2
                class="w-full"
                id="transporters"
                autocomplete
                :value="input.transporter"
                @input="(item) => (input.transporter = item.value)"
                placeholder="Please Select Transporter"
                :options="transportersOptions"
                name="Trasporter"
              />
            </div>

            <!-- amount and payment type -->
            <div class="vx-row">
              <div class="vx-col w-full lg:w-1/2 sm:w-full">
                <!-- amount -->
                <div class="amount mb-2" v-if="modelType === 'pay_now'">
                  <label for="amount">Amount</label>
                  <vs-input type="number" id="amount" name="amount" class="w-full min-w-max" v-model="input.amount" v-validate="`required|min_value:${grandAmount}`" />
                  <span class="text-danger text-sm" v-show="errors.has('amount')">{{ errors.first('amount') }}</span>
                </div>

                <div class="amount mb-2" v-else>
                  <label for="amount">Amount</label>
                  <vs-input type="number" id="amount" name="amount" class="w-full min-w-max" v-model="input.amount" />
                </div>
              </div>

              <div class="vx-col w-full lg:w-1/2 sm:w-full">
                <!-- payment type -->
                <div class="payment_type mb-2">
                  <label for="payment_type">Payment Type</label>
                  <select-2
                    class="w-full"
                    id="payment_type"
                    autocomplete
                    :value="input.payment_type"
                    @input="(item) => (input.payment_type = item.value)"
                    placeholder="Please Select Payment Type"
                    :options="paymentTypes"
                    name="Payment Type"
                  />
                  <span class="text-danger text-sm" v-show="errors.has('Payment Type')">{{ errors.first('Payment Type') }}</span>
                </div>
              </div>
            </div>

            <!-- payment note -->
            <div class="payment_note mb-2">
              <label for="payment_note">Payment Note</label>
              <vs-textarea v-model="input.payment_note" />
            </div>

            <hr />
          </div>

          <!-- add payment row btn -->
          <div class="text-center" v-if="modelType !== 'pay_now'">
            <vs-button class="w-1/2 p-2" color="primary" type="filled" @click="addPaymentRow"> Add Payment Row </vs-button>
          </div>
        </div>

        <!-- Checkout price Details -->
        <div class="vx-col w-full lg:w-2/5 sm:w-2/5">
          <div class="checkout_details p-1">
            <div class="vx-row p-3">
              <div class="vx-col w-1/2">Total Items:</div>
              <div class="vx-col w-1/2 checkout_detail_value">{{ $parent.total_quantity | weightFilter }}</div>
            </div>
            <div class="vx-row p-3">
              <div class="vx-col w-1/2">Tax:</div>
              <div class="vx-col w-1/2 checkout_detail_value">$ {{ $parent.total_tax | currencyFilter }}</div>
            </div>
            <div class="vx-row p-3">
              <div class="vx-col w-1/2">Discount(-):</div>
              <div class="vx-col w-1/2 checkout_detail_value">$ {{ $parent.total_discount | currencyFilter }}</div>
            </div>
            <div class="vx-row p-3">
              <div class="vx-col w-1/2">Total Payable:</div>
              <div class="vx-col w-1/2 checkout_detail_value">$ {{ $parent.grand_total | currencyFilter }}</div>
            </div>
            <div class="vx-row p-3">
              <div class="vx-col w-1/2">Total Paying:</div>
              <div class="vx-col w-1/2 checkout_detail_value">$ {{ totalPayingAmount | currencyFilter }}</div>
            </div>
            <div class="vx-row p-3">
              <div class="vx-col w-1/2">Balance:</div>
              <div class="vx-col w-1/2 checkout_detail_value">$ {{ availableBalance | currencyFilter }}</div>
            </div>
            <div class="vx-row p-3">
              <div class="vx-col w-1/2">Change Return:</div>
              <div class="vx-col w-1/2 checkout_detail_value">$ {{ calculateChangeReturn | currencyFilter }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- footer -->
      <div class="footer text-right">
        <vs-button class="mt-3 p-3 text-sm" color="danger" type="filled" @click="closePaymentInvoiceModel"> Close </vs-button>

        <vs-button class="mt-3 ml-2 p-3 text-sm" color="primary" type="filled" @click="create_sale_invoice" :disabled="!validatePayingAmount"> Complete </vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { paymentTypes, paymentMixins } from '@/utils/paymentTypes'
import { weightMixins } from '@/utils/weightType'
import { taxMode, discountApplicableType } from '@/utils/enums'
import Select2 from '@/components/custom/form-elements/Select2.vue'

export default {
  name: 'InvoicePayment',

  props: {
    is_popup_active: Boolean,
    invoice__products: Array,
    modelType: String,
    customer: Number
  },

  components: {
    Select2
  },

  data() {
    return {
      search: '',
      paymentrows: [],
      transportersOptions: [],

      // payments
      paymentDetails: {
        transporter: null,
        amount: 0,
        payment_type: null,
        payment_note: ''
      },

      paymentTypes
    }
  },

  computed: {
    ...mapState('product', ['categories']),
    ...mapState('transporter', { loading: 'loading' }),
    ...mapState('pos', { loading: 'loading' }),

    // validate paying amount
    validatePayingAmount() {
      return !this.errors.any()
    },

    // calculate total paying amount
    totalPayingAmount() {
      if (this.paymentrows.length === 0) {
        return 0
      } else {
        return this.paymentrows.reduce((acc, item) => acc + paymentMixins.methods.mathRound(Number(item.amount), 2), 0)
      }
    },

    // calculate change return = paying amount - grand total
    calculateChangeReturn() {
      if (this.totalPayingAmount > this.$parent.grand_total) {
        return paymentMixins.methods.mathRound(this.totalPayingAmount - this.$parent.grand_total, 2)
      } else {
        return 0
      }
    },

    // calculate available balances = grand total - paying amount
    availableBalance() {
      if (this.$parent.grand_total > this.totalPayingAmount) {
        return paymentMixins.methods.mathRound(this.$parent.grand_total - this.totalPayingAmount, 2)
      } else {
        return 0
      }
    },

    // close the poup
    is_invoice_popup_active: {
      get() {
        return this.is_popup_active
      },
      set(val) {
        this.paymentrows = []
        this.$emit('update:is_popup_active', val)
      }
    },

    grandAmount() {
      return paymentMixins.methods.mathRound(this.$parent.grand_total, 2)
    }
  },

  mixins: [paymentMixins, weightMixins],

  methods: {
    ...mapActions('transporter', { fetchTransporters: 'getTransporters' }),
    ...mapActions('pos', { create_sale: 'create_sale' }),

    // get all transporters
    async getTransporters() {
      try {
        const payload = {
          search: this.search,
          limit: 0,
          page: 1
        }

        const res = await this.fetchTransporters(payload)
        this.transportersOptions = [...res.data]
        this.transportersOptions = this.transportersOptions.reduce((acc, item) => {
          item.label = item.business_name
          item.value = item.id

          acc.push(item)

          return acc
        }, [])
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    // add payment row
    async addPaymentRow() {
      if (this.modelType !== 'pay_now') {
        this.paymentrows.push({
          transporter: null,
          amount: 0,
          payment_type: null,
          payment_note: ''
        })
      }
    },

    // remove payment row
    async removePaymentrow(index) {
      this.paymentrows.splice(index, 1)
    },

    // close payment invoice model
    async closePaymentInvoiceModel() {
      this.is_invoice_popup_active = false
    },

    // create sales invoice
    async create_sale_invoice() {
      if (!(await this.$validator.validate())) {
        return false
      }

      // request obj
      const create_invoice = {}
      // customer details
      create_invoice.customerId = this.customer
      create_invoice.customer_type = this.$parent.customerDetail.customer_type

      // transporter details
      if (this.paymentrows[0].transporter) {
        create_invoice.transporterId = this.paymentrows[0].transporter
      }

      // sub total - sum(price * qty)
      create_invoice.sub_total = this.$parent.calculate_sub_total_without_discount

      // discount
      create_invoice.tot_discount_amt = this.$parent.total_discount

      // tax details
      create_invoice.tot_taxes_amt = this.$parent.total_tax
      create_invoice.tot_city_tax_amt = this.$parent.isCitytax_apply ? paymentMixins.methods.mathRound(this.$parent.cityTax, 2) : 0
      create_invoice.tot_state_tax_amt = this.$parent.isStatetax_apply ? paymentMixins.methods.mathRound(this.$parent.stateTax, 2) : 0
      create_invoice.tot_excise_tax_amt = this.$parent.isExcisetax_apply ? paymentMixins.methods.mathRound(this.$parent.exciseTax, 2) : 0
      create_invoice.tot_county_tax_amt = this.$parent.isCountrytax_apply ? paymentMixins.methods.mathRound(this.$parent.countytax, 2) : 0

      // grand total
      create_invoice.grand_total = this.$parent.grandTotalWithoutRedeemPoints

      // paid amount
      create_invoice.paid_amount = this.totalPayingAmount

      // payment status
      create_invoice.payment_status = this.modelType === 'pay_now' ? 'paid' : create_invoice.paid_amount > 0 ? 'partial' : 'unpaid'

      // payments array
      const payments = []

      this.paymentrows.forEach((element) => {
        const temp_payment_obj = {}

        temp_payment_obj.amount = Number(element.amount)
        temp_payment_obj.payment_note = element.payment_note
        temp_payment_obj.payment_type = element.payment_type

        payments.push(temp_payment_obj)
      })

      create_invoice.payments = payments

      // sales item arrays
      const salesItems = []

      this.invoice__products.forEach((element) => {
        const temp_product_obj = {}

        temp_product_obj.total_tax_percentage = element.total_tax_percentage
        temp_product_obj.productId = element.id
        temp_product_obj.batchId = element.batchId
        temp_product_obj.sales_qty = weightMixins.methods.mathRound(element.itemQuantity, 3)
        temp_product_obj.price_per_unit = element.price
        temp_product_obj.weight_type = element.weight_type

        let tempTotal = 0
        if (
          (this.$parent.categoryTaxes.tax_mode === taxMode.taxNotIncluded && element.discountAmountType === discountApplicableType.preTax) ||
          (this.$parent.categoryTaxes.tax_mode === taxMode.taxIncluded && element.discountAmountType === discountApplicableType.preTax)
        ) {
          tempTotal = Math.max(element.sub_total - element.discountAmount - this.$parent.convertRedeemPointToDollar(element.item_redeem_points), 0)
        } else {
          tempTotal = Math.max(element.sub_total - this.$parent.convertRedeemPointToDollar(element.item_redeem_points), 0)
        }
        temp_product_obj.tot_price = tempTotal

        temp_product_obj.city_tax_amt = this.$parent.isCitytax_apply ? this.$parent.calculate_single_product_tax(element, 'city_tax') : 0
        temp_product_obj.state_tax_amt = this.$parent.isStatetax_apply ? this.$parent.calculate_single_product_tax(element, 'state_tax') : 0
        temp_product_obj.excise_tax_amt = this.$parent.isExcisetax_apply ? this.$parent.calculate_single_product_tax(element, 'excise_tax') : 0
        temp_product_obj.county_tax_amt = this.$parent.isCountrytax_apply ? this.$parent.calculate_single_product_tax(element, 'county_tax') : 0

        temp_product_obj.item_redeem_points = element.item_redeem_points

        temp_product_obj.discountType = element.discountType === 1 ? 'percentage' : 'dollar'
        temp_product_obj.tot_discount = element.discountAmount
        temp_product_obj.discount_amount_type = element.discountAmountType
        temp_product_obj.tot_taxes_amt = temp_product_obj.city_tax_amt + temp_product_obj.state_tax_amt + temp_product_obj.excise_tax_amt + temp_product_obj.county_tax_amt
        temp_product_obj.grand_amt = temp_product_obj.tot_price + temp_product_obj.tot_taxes_amt

        if ([this.categories.PLANT, this.categories.MATURE].includes(element.categoryId)) {
          const plantIds = []

          if (!element.invoice_plants && element.holdSalesPlantSerials) {
            element.invoice_plants = element.holdSalesPlantSerials
          }

          if (element.invoice_plants.length) {
            element.invoice_plants.forEach((element) => {
              plantIds.push(element.plantId)
            })
          }
          temp_product_obj.plantIds = plantIds
        }

        salesItems.push(temp_product_obj)
      })

      create_invoice.salesItems = salesItems

      // add hold invoice id, if hold invoice update
      create_invoice.holdId = this.$parent.update_invoice_id

      // redeem points
      create_invoice.redeem_points = Math.ceil(this.$parent.redeemPoints - this.$parent.tempRedeemPoints)
      // reedem amount
      create_invoice.redeem_dollar = paymentMixins.methods.mathRound(this.$parent.totalRedeemAmount, 2)

      try {
        const { message, data } = await this.create_sale(create_invoice)
        const routeData = this.$router.resolve({
          name: 'sale-invoice-print',
          params: { saleId: data.sales.id }
        })
        window.open(routeData.href, '_blank', '"scrollbars=0,resizable=1,height=600,width=600"')

        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })

        this.is_invoice_popup_active = false

        this.$nextTick(() => {
          this.$emit('sale-created')
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },

  filters: {
    // currencyFilter rounded to 2 point
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(Number(value), 2)
    },

    //weightFilter rounded conversation
    weightFilter(value) {
      return weightMixins.methods.mathRound(Number(value), 3)
    }
  },

  watch: {
    async is_popup_active() {
      if (this.is_popup_active) {
        await this.getTransporters()

        // add new payment note
        this.paymentrows.push({
          transporter: null,
          amount: 0,
          payment_type: 'cash',
          payment_note: ''
        })
      }
    },

    // set loading
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '.invoice__payment',
          scale: 0.45,
          color: 'primary'
        })
      } else {
        this.$vs.loading.close('.invoice__payment > .con-vs-loading')
      }
    }
  },

  beforeRouteLeave(_, __, next) {
    this.is_invoice_popup_active = false
    next()
  }
}
</script>

<style lang="scss">
#invoice__payment {
  .vs-popup {
    width: 50% !important;
  }
  .vs-popup--header {
    background: rgb(0, 102, 34);
    border-radius: unset;
    padding: 0px;

    h3 {
      color: #fff;
      text-align: center;
    }
  }
}
</style>